import { computed, Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useMetadataExperienceApi } from "@/composables/useMetadataExperienceApi";
import { useRouteParams } from "@vueuse/router";

export const EXPERIENCE_LOCATION_QUERY_KEY = "experience-location";

export function useExperienceLocationQuery(experienceId: Ref<string>) {
  const { getLocation } = useMetadataExperienceApi();

  return useQuery({
    queryKey: [EXPERIENCE_LOCATION_QUERY_KEY, experienceId],
    queryFn: () => getLocation(experienceId.value),
    select: ({ data }) => data,
    enabled: computed(() => !!experienceId.value),
  });
}

export function useCurrentExperienceLocationQuery() {
  const experienceId = useRouteParams<string>("id");

  return useExperienceLocationQuery(experienceId);
}
